import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isEditingReport } from '../../utils';

const useHeaderNavigationGuard = () => {
  const [isDisplayModal, setIsDisplayModal] = useState<boolean>(false);
  const [isRegistOrEditOrCopyPage, setIsRegistOrEditOrCopyPage] = useState<boolean>(false);
  const [nextStep, setNextStep] = useState<() => void>(() => () => setIsDisplayModal(false));
  const location = useLocation();

  useEffect(() => {
    setIsRegistOrEditOrCopyPage(isEditingReport(location));
  }, [location]);

  const wrapWithNavigationGuard = (invokedFunction: () => void) => {
    if (isRegistOrEditOrCopyPage) {
      setNextStep(() => () => {
        invokedFunction();
        setIsDisplayModal(false);
      });
      setIsDisplayModal(true);
      return;
    }
    invokedFunction();
  };

  return {
    wrapWithNavigationGuard,
    isDisplayModal,
    handleCloseModal: () => setIsDisplayModal(false),
    handleClickOk: nextStep,
  };
};

export default useHeaderNavigationGuard;
